import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 flex h-[60px] w-full min-w-0 rounded-[10px] lg:rounded-[15px] border border-[#353353] bg-transparent px-[20px] py-[20px] lg:px-[25px] lg:py-[17px] text-[16px] shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-[18px] placeholder:text-foreground",
        "focus-visible:border-[#353353] focus-visible:ring-theme/25 focus-visible:ring-[3px]",
        "[&:-webkit-autofill]:shadow-[inset_0_0_0_1000px_#121124] [&:-webkit-autofill]:[-webkit-text-fill-color:white]",
        "[&:-webkit-autofill:focus]:shadow-[inset_0_0_0_1000px_#121124] [&:-webkit-autofill:hover]:shadow-[inset_0_0_0_1000px_#121124]",
        "aria-invalid:ring-white/5 aria-invalid:border-white/70",
        className
      )}
      {...props}
    />
  )
}

export { Input }
